/* eslint-disable prettier/prettier */
import { TActionBase, TActionCreate, TActionUpdate } from 'types/promotion/action';
import { BaseReponse } from 'types/response';
import { axiosInstances } from 'utils/axios';
import { getUserInfo } from 'utils/utils';

const request = axiosInstances.promotion;

const get = (params?: any) => {
    const userRaw = getUserInfo();
    const user = userRaw ? JSON.parse(userRaw) : {};

    const queryParams = {
        ...params,
        brandId: params?.brandId || user?.brandId,
        pageIndex: params?.pageIndex ?? params?.page,
        pageSize: params?.pageSize ?? params?.size
    };

    delete queryParams.page;
    delete queryParams.size;

    return request.get<BaseReponse<TActionBase>>(`/actions`, { params: queryParams });
};

const createAction = (data?: TActionCreate) => request.post<TActionBase>(`/actions`, data);


const updateAction = (id: string | undefined, data?: TActionUpdate) =>
    request.patch<TActionBase>(`/actions/${id}`, data);

const deleteAction = (id: string | undefined, data?: TActionUpdate) =>
    request.delete<TActionBase>(`/actions/${id}`);

const getActionById = (id?: string) =>
    request.get<TActionBase>(`/actions/${id}`);

const actionApi = { get, createAction, getActionById, updateAction, deleteAction };

export default actionApi;
